import type { Subscription } from '../subscription/types';

export function hasOneOrMoreContracts(subscription: Subscription) {
  return subscription.contracts.length > 0;
}
